import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28b857bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "phone-number" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_4 = {
  href: "https://casedrive.co/terms-and-conditions",
  target: "_blank"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Next ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_checkbox = _resolveComponent("app-checkbox")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      as: "el-form",
      "validation-schema": _ctx.schema,
      validate: "true",
      onSubmit: _ctx.nextStep
    }, {
      default: _withCtx(({errors}) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_app_select, {
            controlClass: "phone-number__code",
            modelValue: _ctx.phoneNumberCodeValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phoneNumberCodeValue) = $event)),
            name: "phoneNumberCode",
            options: _ctx.filteredNumberCodes,
            filterable: "",
            "filter-method": _ctx.searchNumberCode,
            onChange: _ctx.onChangeNumberCode
          }, {
            default: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.item.optionLabel), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "options", "filter-method", "onChange"]),
          _createVNode(_component_app_input, {
            controlClass: "phone-number__input",
            clearable: "",
            modelValue: _ctx.phoneNumberValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phoneNumberValue) = $event)),
            "prop-error": _ctx.phoneNumberError,
            type: "tel",
            inputmode: "tel",
            name: "phoneNumber",
            label: "Phone number",
            placeholder: "Phone number",
            onInput: _ctx.onInputPhoneNumber
          }, {
            "label-append": _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["modelValue", "prop-error", "onInput"])
        ]),
        _createVNode(_component_app_checkbox, {
          class: "app-form-control",
          name: "terms",
          modelValue: _ctx.termsAndConditionsValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.termsAndConditionsValue) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$localize('registration.terms.text1')) + " ", 1),
            _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$localize('registration.terms.link')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$localize('registration.terms.text2')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_app_button, {
          disabled: !_ctx.phoneNumberValue || !_ctx.phoneNumberCodeValue || !!errors.phoneNumber || !_ctx.termsAndConditionsValue,
          type: "primary",
          "native-type": "submit",
          class: "w-100 el-button-lg",
          round: ""
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 2
        }, 1032, ["disabled"])
      ]),
      _: 1
    }, 8, ["validation-schema", "onSubmit"])
  ]))
}